var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBookmark = function SvgBookmark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M14.889 16.431a.5.5 0 0 1-.765.424l-3.859-2.412a.5.5 0 0 0-.53 0l-3.859 2.412a.5.5 0 0 1-.765-.424V3.89a.61.61 0 0 1 .611-.611h8.556a.61.61 0 0 1 .61.61z"
  })));
};
export default SvgBookmark;